import "../../lodging/lodging-details/lodging-details.css";
import "../../VendorDetails.css";

import React, { useContext, useEffect, useState } from "react";
import { Form, Row, Col, Tab, Nav, Carousel, Button, Modal, Spinner } from "react-bootstrap";
import reactMoment from "react-day-picker/moment";
import Amenity from "../../../../../../../Data/Amenity";
import TransportItem from "../../../../../../../Data/TransportItem";
import VendorUnit from "../../../../../../../Data/VendorUnit";
import VendorUnitImage from "../../../../../../../Data/VendorUnitImage";
import { DatesAndGuests } from "../../../../widget-form/WidgetForm";
import RatesByDate from "../../../../../../../Data/Rates/DateRate";
import UnitRate from "../../../../../../../Data/Rates/UnitRate";
import ProductRate from "../../../../../../../Data/Rates/ProductRate";
import { WidgetContext } from "../../../../../../../context/WidgetContext";
import { MobileDayPickerOverlay } from "../../../../assets/MobileDayPickerOverlay";
import moment from "moment";
import { getAvailableVendorUnits, getDailyRate, getHourlyRate, getRateTypeFromUnitName, getUnitRate, getVendorUnitIdFromUnitName, populateTimes, getVendorUnitIdsFromSelectedName } from "../../../../../../../Data/Rates/UnitRateLogic";
import EnumProductRateType from "../../../../../../../Data/Rates/EnumProductRateType";
import Decimal from "decimal.js";
import { roundDecimal, isStringEmpty } from "../../../../../../../_helpers/Functions";
import CustomDayPickerInput from "../../../../../customDayPickerInput/CustomDayPickerInput";
import UseGetTransportVendors, { GetTransportVendorsRequest } from "../add-transportation/data-service-hooks/UseGetTransportVendors";

interface props {
  vendor: TransportItem;
  datesAndGuests: DatesAndGuests;
  onSelectedVendorUnit?: (item: TransportItem, index?: number) => void;
}

interface GeoProps {
  lat: number;
  lng: number;
}

const TransportDetails: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint, autoScroll, brand } = useContext(WidgetContext);

  const { datesAndGuests, onSelectedVendorUnit } = props;
  const [vendor, setVendor] = useState(props.vendor);
  const [vendorUnits, setVendorUnits] = useState<VendorUnit[]>([]);
  const rates = vendor && vendor.dailyRates ? vendor.dailyRates : [];

  const isEditing = vendor.itineraryIndex !== undefined && vendor.itineraryIndex > -1;

  // const [datesAndGuests, setDatesAndGuests] = useState<DatesAndGuests>(props.datesAndGuests);
  const [guests, setGuests] = useState(vendor.numberOfGuests !== undefined ? vendor.numberOfGuests : datesAndGuests.guests);
  const [units, setUnits] = useState(vendor.numberOfUnits !== undefined ? vendor.numberOfUnits : datesAndGuests.units);
  const [startDate, setStartDate] = useState<string>(!isStringEmpty(vendor.startDate) ? vendor.startDate : datesAndGuests.fromDate.toDateString());
  const [endDate, setEndDate] = useState<string>(!isStringEmpty(vendor.endDate) ? vendor.endDate : datesAndGuests.toDate.toDateString());
  const [startTime, setStartTime] = useState<string | undefined>("09:00");
  const [endTime, setEndTime] = useState<string | undefined>("09:00");
  const [startTimes, setStartTimes] = useState<any[]>([]);
  const [endTimes, setEndTimes] = useState<any[]>([]);
  const modifiers = { start: startDate, end: endDate };

  const { formatDate, parseDate } = reactMoment;

  const [latlang, setLatLang] = useState<GeoProps>();
  const [geoLocation, setGeoLocation] = useState("");

  // const [currentProductRate, setCurrentProductRate] = useState<ProductRate>();
  const maxGuests = datesAndGuests.guests;

  const [hourlyRates, setHourlyRates] = useState<UnitRate[]>([]);
  const [isHourlyRate, setIsHourlyRate] = useState<boolean>(false);
  const [unitRates, setUnitRates] = useState<UnitRate[]>([]);
  const [isUnitRate, setIsUnitRate] = useState<boolean>(false);
  const [dayRates, setDayRates] = useState<RatesByDate[]>([]);
  const [isDailyRate, setIsDailyRate] = useState<boolean>(false);
  const [unavailableMessage, setUnavailableMessage] = useState<string | undefined>();

  const [selectedProductRateType, setSelectedProductRateType] = useState<number | null>(null); //vendorUnit.productRateTypeId
  const [selectedUnit, setSelectedUnit] = useState<number | null>(null); //vendorUnitId
  const [selectedProductRate, setSelectedProductRate] = useState<ProductRate | null>(null);

  const [selectedUnitName, setSelectedUnitName] = useState<string | null>(null);
  const [vendorUnitIds, setVendorUnitIds] = useState<Number[]>([]);

  const [rangePickerMode, setRangePickerMode] = useState<boolean>(true);

  const [unitRateTotal, setUnitRateTotal] = useState(0);
  const [unitRateAverage, setUnitRateAverage] = useState(0);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [getTransportVendorsRequest, setGetTransportVendorsRequest] = useState<GetTransportVendorsRequest>();
  const responseGetTransportVendors = UseGetTransportVendors(getTransportVendorsRequest);

  const [imgErrors, setImgErrors] = useState<number[]>([]);
  const placeholderImgUrl = "https://images.unsplash.com/photo-1566073771259-6a8506099945?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80";

  const [index, setIndex] = useState(0);

  useEffect(() => {
    setVendor(props.vendor);
  }, [props.vendor]);

  const handleSelect = (selectedIndex: any, e: any) => {
    setIndex(selectedIndex);
  };

  const onGuestsInputChanged = (event: any) => {
    setGuests(+event.target.value);
  }

  const onUnitsInputChanged = (event: any) => {
    setUnits(+event.target.value);
  }

  const onStartDateChanged = (date: Date) => {
    setStartDate(date.toDateString());
    const d = moment(date);
    if (d.isAfter(moment(endDate))) {
      setEndDate(date.toDateString());
    }
  }

  const startTimeOptions = startTimes.map((time: any, index: number) => (
    <option value={time.value} key={index}>{time.label}</option>
  ));

  const endTimeOptions = endTimes.map((time: any, index: number) => (
    <option value={time.value} key={index}>{time.label}</option>
  ));

  const onEndDateChanged = (date: Date) => {
    setEndDate(date.toDateString());
  }

  function getNumGuestsOptions(): JSX.Element[] {
    const options: JSX.Element[] = [];

    for (let index = 0; index < maxGuests; index++) {
      options.push(<option key={`transport guests option ${index}`}>{index + 1}</option>);
    }

    return options;
  }

  function getNumUnitsOptions(): JSX.Element[] {
    const options: JSX.Element[] = [];

    for (let index = 0; index < guests; index++) {
      options.push(<option key={`transport units option ${index}`}>{index + 1}</option>);
    }

    return options;
  }

  function addClick(unit: VendorUnit) {
    unit.vendorId = vendor.vendorId;

    unit.sell = unitRateTotal;

    vendor.selectedUnit = unit;
    vendor.startDate = startDate;
    vendor.endDate = isDailyRate ? endDate : startDate;
    vendor.startTime = startTime ?? "";
    vendor.endTime = endTime ?? "";
    vendor.numberOfGuests = guests;
    vendor.numberOfUnits = units;

    if (onSelectedVendorUnit)
      onSelectedVendorUnit(vendor, vendor.itineraryIndex);
  }

  const unitOptions = vendorUnits.filter(u => u.published).map((unit: VendorUnit, index: number) => (
    <option value={unit.uniqueIdForSelection} key={index}>{unit.unitName}</option>
  ));

  useEffect(() => {
    // map
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${vendor.streetAddress},+${vendor.city},+${vendor.state}&key=AIzaSyAJ1DlLWQ9UpZ_46ufaWXdTzb6epSr87sU`
    ).then((response) => {
      return response.json();
    }).then((response) => {
      setLatLang({ lat: response.results[0].geometry.location.lat, lng: response.results[0].geometry.location.lng });
    });
  }, []);

  useEffect(() => {
    if (latlang) {

      let geolocationString = `https://www.google.com/maps/embed/v1/view?key=AIzaSyAJ1DlLWQ9UpZ_46ufaWXdTzb6epSr87sU
        &center=${latlang.lat},${latlang.lng}
        &zoom=15
        &maptype=roadmap`;

      setGeoLocation(geolocationString);
    }
  }, [latlang]);

  useEffect(() => {
    if (vendor === undefined) return;

    let result = populateTimes();
    setStartTimes(result);
    setEndTimes(result);

    let _vendorUnits = getAvailableVendorUnits(vendor.vendorUnits, rates, moment(startDate).format("MM/DD/YYYY"), moment(endDate).format("MM/DD/YYYY"));
    _vendorUnits.sort((a, b) => {
      if (a.sortOrder < b.sortOrder) return -1;
      if (a.sortOrder > b.sortOrder) return 1;

      if (a.unitName.toLowerCase() < b.unitName.toLowerCase()) return -1;
      if (a.unitName.toLowerCase() > b.unitName.toLowerCase()) return 1;

      return 0;
    });
    setVendorUnits(_vendorUnits);

    if (_vendorUnits.findIndex(a => a.uniqueIdForSelection == selectedUnitName) < 0) {
      if (_vendorUnits.length > 0) {
        setSelectedUnitName(_vendorUnits[0].uniqueIdForSelection);
      }
    }

    setUnavailableMessage('');

    setVendorUnitIds(getVendorUnitIdsFromSelectedName(rates, selectedUnitName, moment(startDate).format("MM/DD/YYYY"), moment(endDate).format("MM/DD/YYYY")));

  }, [vendor, startDate, endDate]);

  useEffect(() => {
    setIsDailyRate(false);
    setIsHourlyRate(false);
    setIsUnitRate(false);

    if (selectedProductRateType == EnumProductRateType.DayRange) {
      setIsDailyRate(true);
      //multiple days
      setRangePickerMode(true);
      // setEndDate(props.maxDate);

      setStartTime("09:00");
      setEndTime("09:00");
    }
    else if (selectedProductRateType == EnumProductRateType.HoursPerUnit) {
      setIsHourlyRate(true);
      //single day
      setRangePickerMode(false);
      // setEndDate(null);

      setStartTime("09:00");
      setEndTime("10:00");

    }
    else if (selectedProductRateType == EnumProductRateType.UnitQtyRange) {
      setIsUnitRate(true);
      //single day
      setRangePickerMode(false);
      // setEndDate(null);

      setStartTime("09:00");
    }
  }, [selectedProductRateType]);

  useEffect(() => {
    if (!selectedUnitName) {
      return;
    }

    const rateType = getRateTypeFromUnitName(vendor.dailyRates, selectedUnitName);

    setSelectedProductRateType(rateType);
    setVendorUnitIds(getVendorUnitIdsFromSelectedName(rates, selectedUnitName, moment(startDate).format("MM/DD/YYYY"), moment(endDate).format("MM/DD/YYYY")));
  }, [selectedUnitName]);

  useEffect(() => {
    setIndex(0);
  }, [vendorUnitIds]);

  useEffect(() => {
    if (!isDailyRate) {
      return;
    }

    const { productRates, noRateMessage } = getDailyRate(vendor.dailyRates, selectedUnitName, startDate, endDate, startTime, endTime);
    setSelectedProductRate(productRates !== undefined && productRates.length > 0 ? (productRates[0] !== undefined ? productRates[0] : null) : null);

    if (!!noRateMessage) {
      setUnavailableMessage(noRateMessage);
      return;
    }

    const rate = productRates.reduce((a, b) => a.add(new Decimal(b ? b.price : 0)), new Decimal(0));
    setUnitRateTotal(roundDecimal(rate.times(units)).toNumber());
    setUnitRateAverage(roundDecimal(rate.dividedBy(productRates.length === 0 ? 1 : productRates.length)).toNumber());

    setUnavailableMessage(undefined);
  }, [isDailyRate, dayRates, units, startTime, endTime, startDate, endDate, selectedUnitName]);

  useEffect(() => {
    if (!(isHourlyRate && startTime && endTime)) {
      return;
    }

    var numberOfHours: number = moment.duration(moment(endTime, 'HH:mm').diff(moment(startTime, 'HH:mm'))).asHours();

    if (numberOfHours < 0) {
      //only 0-24 hours
      numberOfHours = moment.duration(moment(endTime, 'HH:mm').add(1, "day").diff(moment(startTime, 'HH:mm'))).asHours();
    }

    let hourlyRate = getHourlyRate(vendor.dailyRates, selectedUnitName, startTime, endTime);
    setSelectedProductRate(hourlyRate === undefined ? null : hourlyRate);

    if (!hourlyRate) {
      setUnavailableMessage(`No rates available for ${numberOfHours} hours.`);
      setUnitRateTotal(0);
      return;
    }
    // console.log("productRates.length", productRates.length);

    const rate = (new Decimal(hourlyRate.price).times(numberOfHours));
    // setCurrentProductRate(hourlyRate);
    setUnitRateTotal(roundDecimal(rate.times(units)).toNumber());
    setUnitRateAverage(roundDecimal(rate.dividedBy(numberOfHours === 0 ? 1 : numberOfHours)).toNumber());
    setUnavailableMessage(undefined);
    setVendorUnitIds(getVendorUnitIdsFromSelectedName(rates, selectedUnitName, moment(startDate).format("MM/DD/YYYY"), moment(endDate).format("MM/DD/YYYY")));
  }, [isHourlyRate, hourlyRates, startTime, endTime, units, selectedUnit, startDate, selectedUnitName]);

  useEffect(() => {
    if (!(isUnitRate)) {
      return;
    }

    let unitRate = getUnitRate(vendor.dailyRates, selectedUnitName, units);
    setSelectedProductRate(unitRate === undefined ? null : unitRate);

    if (!unitRate) {
      setUnavailableMessage(`No rates available for ${units} units.`)
      setUnitRateTotal(0);
      return;
    }

    const rate = new Decimal(unitRate.price).times(units);
    setUnitRateTotal(roundDecimal(rate).toNumber());
    setUnavailableMessage(undefined);
    setVendorUnitIds(getVendorUnitIdsFromSelectedName(rates, selectedUnitName, moment(startDate).format("MM/DD/YYYY"), moment(endDate).format("MM/DD/YYYY")));

  }, [isUnitRate, unitRates, units, startDate, startTime, selectedUnitName]);

  useEffect(() => {
    setIndex(0);
  }, [vendorUnitIds]);

  useEffect(() => {
    if (brand === undefined) return;

    setGetTransportVendorsRequest({ brandId: brand?.brandId as number, startDate: moment(datesAndGuests.fromDate).format('YYYY-MM-DD'), endDate: moment(datesAndGuests.toDate).format('YYYY-MM-DD'), vendorId: vendor.vendorId });
  }, [props.vendor]);

  useEffect(() => {
    if (responseGetTransportVendors.data) {
      const responseData = responseGetTransportVendors.data;

      if (responseData.length > 0) {
        responseData[0].itineraryIndex = vendor.itineraryIndex;
        setVendor(responseData[0]);
      }
      setIsLoading(false);
    }
  }, [responseGetTransportVendors.data]);

  const inputStyle = `
  .inline-style .DayPickerInput>input {
  padding-left: 15px;
}`;

  const navLinkStyles = `
  .nav-pills .nav-link.active {
    background-color: rgb(247, 247, 247);
    color: ${style.buttonColor} !important;
}`;

  return (
    <React.Fragment>
      <style>{inputStyle}</style>
      <style>{navLinkStyles}</style>

      {/* Desktop */}
      <div className="d-none d-lg-block widget-font">
        {/* Dates */}
        <Row>
          <Row className="w-100 m-0 p-0">
            <Col md={7}>
              <Row className="d-flex flex-row justify-content-between">
                <Col xs={rangePickerMode ? 6 : 12} className={`${rangePickerMode ? "pr-1" : ""} d-flex flex-column InputFromTo`}>
                  <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                    Start Date
                  </Form.Label>
                  <CustomDayPickerInput
                    inputProps={{ style: { color: style.fontColor } }}
                    value={moment(startDate).format("ddd, MMM Do, YYYY")}
                    placeholder="Check In"
                    format="LL"
                    formatDate={formatDate}
                    parseDate={parseDate}
                    dayPickerProps={{
                      selectedDays: { from: !isStringEmpty(startDate) ? moment(startDate).toDate() : datesAndGuests.fromDate, to: !isStringEmpty(endDate) ? moment(endDate).toDate() : datesAndGuests.toDate },
                      disabledDays: { before: datesAndGuests.fromDate, after: datesAndGuests.toDate },
                      numberOfMonths: 1,
                      month: datesAndGuests.fromDate,
                      modifiers
                    }}
                    onDayChange={onStartDateChanged}
                  />
                </Col>
                {rangePickerMode && (
                  <Col xs={6} className="pl-1 d-flex flex-column InputFromTo">
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      End Date
                    </Form.Label>
                    <CustomDayPickerInput
                      inputProps={{ style: { color: style.fontColor } }}
                      value={moment(endDate).format("ddd, MMM Do, YYYY")}
                      placeholder="Check Out"
                      format="LL"
                      formatDate={formatDate}
                      parseDate={parseDate}
                      dayPickerProps={{
                        selectedDays: { from: !isStringEmpty(startDate) ? moment(startDate).toDate() : datesAndGuests.fromDate, to: !isStringEmpty(endDate) ? moment(endDate).toDate() : datesAndGuests.toDate },
                        disabledDays: { before: !isStringEmpty(startDate) ? moment(startDate).toDate() : datesAndGuests.fromDate, after: datesAndGuests.toDate },
                        modifiers,
                        numberOfMonths: 1,
                        month: datesAndGuests.fromDate,
                      }}
                      onDayChange={onEndDateChanged}
                    />
                  </Col>
                )}
              </Row>

              <Row>
                {!isLoading && vendorUnits.length > 0 && (
                  <div className="w-100 d-flex flex-column" style={{ marginTop: "10px" }}>
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      Unit Type
                    </Form.Label>
                    <Form.Control
                      style={{ color: style.fontColor }}
                      as="select"
                      className=""
                      value={selectedUnitName || undefined}
                      onChange={(event: any) => {
                        setSelectedUnitName(event.currentTarget.value)
                      }} >
                      <option value="" disabled hidden>Select a unit</option>
                      {unitOptions}
                    </Form.Control>
                  </div>
                )}

                {isLoading && (
                  <span className="mt-2"><Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  /> Loading...</span>
                )}
              </Row>

              {!isLoading && (
                <Row style={{ marginTop: "10px" }}>
                  <div className="d-flex flex-column mr-3">
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      Guests
                  </Form.Label>
                    <Form.Control
                      style={{ color: style.fontColor }}
                      as="select"
                      name="guests"
                      className="guest-select"
                      value={guests.toString()}
                      onChange={onGuestsInputChanged}
                    >
                      {getNumGuestsOptions()}
                    </Form.Control>
                  </div>
                  <div className="d-flex flex-column pr-2">
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      Units
                  </Form.Label>
                    <Form.Control
                      style={{ color: style.fontColor }}
                      as="select"
                      name="units"
                      className="guest-select"
                      value={units.toString()}
                      onChange={onUnitsInputChanged}
                    >
                      {getNumUnitsOptions()}
                    </Form.Control>
                  </div>
                  <div className="d-flex flex-column pl-2">
                    <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                      Start Time
                  </Form.Label>
                    <Form.Control
                      style={{ color: style.fontColor }}
                      as="select"
                      className="time-select p-1"
                      value={startTime}
                      onChange={(event: any) => {
                        setStartTime(event.currentTarget.value);
                        // setEndTime(null);
                      }}
                    >
                      {startTimeOptions}
                    </Form.Control>
                  </div>
                  {(isHourlyRate || isDailyRate) && (
                    <div className="d-flex flex-column pl-3">
                      <Form.Label className="font-weight-bold" style={{ color: style.fontColor, fontSize: 14 }}>
                        End Time
                    </Form.Label>
                      <Form.Control
                        style={{ color: style.fontColor }}
                        as="select"
                        className="time-select p-1"
                        value={endTime}
                        onChange={(event: any) => {
                          setEndTime(event.currentTarget.value)
                        }}
                      >
                        {endTimeOptions}
                      </Form.Control>
                    </div>
                  )}
                </Row>
              )}
            </Col>

            {!isLoading && (
              <Col md={5} className="pl-2 pb-1 d-flex flex-row justify-content-end align-items-end">
                {!!!unavailableMessage && (<>
                  {(selectedProductRate !== null && selectedProductRate.displayVendorPriceOverride) || !vendor.rateDisplayOption.showPkgPriceOnly && startWidget.showTransportationPricing ? (
                    <div className="add-buttons mr-3">
                      <p className="m-0 p-0 pr-3 font-weight-bold green-text" >${unitRateAverage.toFixed(2)}</p>
                    </div>
                  ) : (<>
                    <div className="add-buttons mr-3">
                      <p className="m-0 p-0 pr-3 font-weight-bold green-text" >Package Price</p>
                    </div>
                  </>)}
                  <div className="add-buttons">
                    <Button
                      style={{ backgroundColor: style.buttonColor }}
                      className="lodging-detail-button add-button box-shadow"
                      onClick={() => {
                        const _unitId = getVendorUnitIdFromUnitName(vendor.dailyRates, selectedUnitName);
                        if (_unitId)
                          addClick(vendor.vendorUnits.find(unit => unit.vendorUnitId == _unitId) as VendorUnit);
                        // const vu = vendor.vendorUnits.find(unit => unit.vendorUnitId == selectedUnit) as VendorUnit;
                        // addClick(vu);
                      }}
                    >
                      Add
                  </Button>
                  </div>
                </>)}
              </Col>
            )}
          </Row>

          {vendor.vendorUnits.find(unit => unit.vendorUnitId === selectedUnit)?.unitDescription && (
            <Row className="m-0 p-0 my-2">
              <p className="m-0 p-0">{vendor.vendorUnits.find(unit => unit.vendorUnitId === selectedUnit)?.unitDescription}</p>
            </Row>
          )}

          {unavailableMessage !== undefined && (
            <Row className="m-0 p-0 my-2">
              <p className="m-0 p-0 font-italic text-danger">{unavailableMessage}</p>
            </Row>
          )}
        </Row>

        {!isLoading && (
          <Tab.Container id="left-tabs-example" defaultActiveKey="photos">
            <Row className="widget-font">
              <Col xs={12} className="mobile-details-nav">
                <Nav variant="pills">
                  <Nav.Item>
                    <Nav.Link eventKey="photos" style={{ color: style.linkColor }}>Photos</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="about" style={{ color: style.linkColor }}>About</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="amenities" style={{ color: style.linkColor }}>Amenities</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="map" style={{ color: style.linkColor }}>Map</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col
                xs={12}
                className="details-tab-content"
                style={{
                  backgroundColor: "rgb(222, 222, 222)",
                  marginTop: "0px",
                }}
              >
                <Tab.Content style={{ backgroundColor: "rgb(222, 222, 222)" }}>
                  {/* Photos */}
                  <Tab.Pane eventKey="photos">
                    <Carousel activeIndex={index} onSelect={handleSelect} indicators={false}
                      style={{
                        backgroundColor: "#F7F7F7",
                      }}
                    >
                      {/* Vendor Units has images now */}
                      {vendor.vendorUnits && vendor.vendorUnits.some(u => u.vendorUnitId === selectedUnit && u.vendorUnitImages.length > 0) &&
                        vendor.vendorUnits.filter(u => u.vendorUnitId === selectedUnit).map((unit: VendorUnit) => {
                          return unit.vendorUnitImages.map((image: VendorUnitImage, index: number) => {
                            return (<Carousel.Item
                              key={`${unit.unitName}-${unit.vendorUnitId}-${index}`}
                              style={{
                                height: "auto",
                                backgroundColor: "#F7F7F7",
                              }}
                            >
                              <img
                                className="d-block w-100"
                                src={image.imageUrl}
                                alt={image.name}
                              />
                              <Carousel.Caption>
                                <p>{image.description}</p>
                              </Carousel.Caption>
                            </Carousel.Item>
                            )
                          })
                        })
                      }

                      {vendor.vendorUnits && !vendor.vendorUnits.some(u => u.vendorUnitId === selectedUnit && u.vendorUnitImages.length > 0) && (
                        <img
                          className="d-block w-100"
                          style={{
                            height: "500px",
                            backgroundColor: "#F7F7F7",
                          }}
                          src={vendor.description != undefined && vendor.description.vendorDescriptionImages.length > 0 ? vendor.description.vendorDescriptionImages[0].vendorImageUrl as string : ""}
                          alt={""}
                        />
                      )}
                    </Carousel>
                  </Tab.Pane>
                  <Tab.Pane className="p-3" eventKey="about" style={{ height: "auto" }}>
                    <p style={{ color: style.fontColor }}>{vendor.description ? vendor.description.description : ""}</p>
                  </Tab.Pane>
                  <Tab.Pane
                    className="p-3"
                    eventKey="amenities"
                    style={{
                      backgroundColor: "rgb(222, 222, 222)",
                      height: "auto",
                    }}
                  >
                    {vendor.amenities.map((item: Amenity) => (
                      <p style={{ backgroundColor: "rgb(222, 222, 222)", color: style.fontColor }}>
                        {item.amenityName}
                      </p>
                    ))}
                  </Tab.Pane>
                  <Tab.Pane eventKey="map" style={{ height: "auto" }}>
                    <div
                      className="d-flex flex-column align-items-center"
                    >
                      <iframe
                        className="map"
                        title="map"
                        // disableDefaultUI="true"
                        src={geoLocation}
                      ></iframe>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        )}
      </div>

      {/* Mobile */}
      <div className="d-lg-none">
        <Col className="d-flex flex-column align-items-center mobile-widget d-lg-none">
          <Col className="justify-content-center">
            {/* Room Type Select */}
            <div
              className="d-flex flex-row justify-content-between"
            >
              {vendorUnits.length > 0 && (
                <Form.Control
                  className="p-2"
                  style={{ color: style.fontColor }}
                  as="select"
                  value={selectedUnitName || undefined}
                  onChange={(event: any) => {
                    setSelectedUnitName(event.currentTarget.value)
                  }} >
                  <option value="" disabled hidden>Select a unit</option>
                  {unitOptions}
                </Form.Control>
              )}
            </div>

            {/* Arrive DatePicker */}
            <div className="mobile InputFromTo" style={{ marginRight: "0px" }}>
              <Row className="mt-3">
                <CustomDayPickerInput
                  overlayComponent={MobileDayPickerOverlay}
                  inputProps={{ readOnly: true, style: { color: style.fontColor } }}
                  value={`Start: ${moment(startDate).format("ddd, MMM Do, YYYY")}`}
                  placeholder="Start Date"
                  format="LL"
                  formatDate={formatDate}
                  parseDate={parseDate}
                  dayPickerProps={{
                    selectedDays: { from: !isStringEmpty(startDate) ? moment(startDate).toDate() : datesAndGuests.fromDate, to: !isStringEmpty(endDate) ? moment(endDate).toDate() : datesAndGuests.toDate },
                    disabledDays: { before: datesAndGuests.fromDate as Date, after: datesAndGuests.toDate },
                    numberOfMonths: 1,
                    month: datesAndGuests.fromDate,
                    modifiers
                  }}
                  onDayChange={onStartDateChanged}
                />
              </Row>
            </div>

            {rangePickerMode && (
              <>
                {/* Depart DatePicker */}
                < div className="mobile InputFromTo" style={{ marginRight: "0px" }}>
                  <Row className="mt-3">
                    <CustomDayPickerInput
                      overlayComponent={MobileDayPickerOverlay}
                      inputProps={{ readOnly: true, style: { color: style.fontColor } }}
                      value={`End: ${moment(endDate).format("ddd, MMM Do, YYYY")}`}
                      placeholder="End Date"
                      format="LL"
                      formatDate={formatDate}
                      parseDate={parseDate}
                      dayPickerProps={{
                        selectedDays: { from: !isStringEmpty(startDate) ? moment(startDate).toDate() : datesAndGuests.fromDate, to: !isStringEmpty(endDate) ? moment(endDate).toDate() : datesAndGuests.toDate },
                        disabledDays: { before: !isStringEmpty(startDate) ? moment(startDate).toDate() : datesAndGuests.fromDate, after: datesAndGuests.toDate },
                        numberOfMonths: 1,
                        month: datesAndGuests.fromDate,
                        modifiers
                      }}
                      onDayChange={onEndDateChanged}
                    />
                  </Row>
                </div>
              </>
            )}

            <div className="d-flex flex-row justify-content-start mt-3">
              <div className="d-flex flex-row mr-3">
                <Form.Label style={{ marginTop: "10px", marginRight: "5px", color: style.fontColor }}>
                  From:
                </Form.Label>
                <Form.Control
                  style={{ color: style.fontColor }}
                  as="select"
                  name="teeTime"
                  className="time-select p-1"
                  value={startTime}
                  onChange={(event: any) => {
                    setStartTime(event.currentTarget.value);
                    // setEndTime(null);
                  }}
                >
                  {startTimeOptions}
                </Form.Control>
              </div>

              {(isHourlyRate || isDailyRate) && (
                <div className="d-flex flex-row mr-3">
                  <Form.Label style={{ marginTop: "10px", marginRight: "5px", color: style.fontColor }}>
                    To:
                  </Form.Label>
                  <Form.Control
                    style={{ color: style.fontColor }}
                    as="select"
                    name="teeTime"
                    className="time-select p-1"
                    value={endTime}
                    onChange={(event: any) => {
                      setEndTime(event.currentTarget.value);
                    }}
                  >
                    {endTimeOptions}
                  </Form.Control>
                </div>
              )}
            </div>

            {!isLoading && (
              <div className="d-flex flex-row justify-content-start mt-3">
                {/* Guests */}
                <div className="d-flex flex-row">
                  <Form.Label
                    className="pt-0"
                    style={{
                      paddingRight: "5px",
                      marginBottom: "0px",
                      marginTop: "8px",
                      color: style.fontColor
                    }}
                  >
                    Guests:
                </Form.Label>
                  <Form.Control
                    style={{ color: style.fontColor }}
                    as="select"
                    name="guests"
                    className="guest-select"
                    value={guests.toString()}
                    onChange={onGuestsInputChanged}
                  >
                    {getNumGuestsOptions()}
                  </Form.Control>
                </div>

                <div className="pr-5 d-flex flex-row">
                  <Form.Label
                    className="pt-0 ml-2"
                    style={{
                      paddingRight: "5px",
                      marginBottom: "0px",
                      marginTop: "8px",
                      color: style.fontColor
                    }}
                  >
                    Units:
                </Form.Label>
                  <Form.Control
                    as="select"
                    name="units"
                    className="guest-select"
                    style={{ color: style.fontColor }}
                    value={units.toString()}
                    onChange={onUnitsInputChanged}
                  >
                    {getNumUnitsOptions()}
                  </Form.Control>
                </div>
              </div>
            )}

            {vendor.vendorUnits.find(unit => unit.vendorUnitId === selectedUnit)?.unitDescription && (
              <Row className="m-0 p-0 my-2">
                <p className="m-0 p-0">{vendor.vendorUnits.find(unit => unit.vendorUnitId === selectedUnit)?.unitDescription}</p>
              </Row>
            )}

            {/* Package Price */}
            {!isLoading && !!!unavailableMessage && (
              <div className="w-100 d-flex flx-row justify-content-between mt-3">

                {(selectedProductRate !== null && selectedProductRate.displayVendorPriceOverride) || !vendor.rateDisplayOption.showPkgPriceOnly && startWidget.showTransportationPricing ? (
                  <div className="pt-2">
                    <p className="m-0 p-0 pr-3 font-weight-bold green-text" style={{ fontSize: "18px" }}>${unitRateAverage.toFixed(2)}</p>
                  </div>
                ) : (<>
                  <div className="add-buttons">
                    <p className="m-0 p-0 pr-3 font-weight-bold green-text">Package Price</p>
                  </div>
                </>)}

                <Button
                  type="submit"
                  className="mobile-add-button"
                  style={{
                    marginBottom: "2px",
                    marginTop: "3px",
                    backgroundColor: style.buttonColor
                  }}
                  onClick={() => {
                    const _unitId = getVendorUnitIdFromUnitName(vendor.dailyRates, selectedUnitName);
                    if (_unitId)
                      addClick(vendor.vendorUnits.find(unit => unit.vendorUnitId == _unitId) as VendorUnit);
                    // const vu = vendor.vendorUnits.find(unit => unit.vendorUnitId == selectedUnit) as VendorUnit;
                    // addClick(vu);
                  }}
                >
                  + {isEditing ? "Save" : "Add"}
                </Button>
              </div>)}

            {unavailableMessage && (
              <Row className="m-0 p-0 my-2">
                <p className="m-0 p-0 font-italic text-danger">{unavailableMessage}</p>
              </Row>
            )}

            {!isLoading && (
              <div className="d-flex flex-row justify-content-center">
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="photos"
                // style={{ marginTop: "0px" }}
                >
                  <Row
                    className="w-100 justify-content-center widget-font"
                  >
                    <Col className="details-nav">
                      <Nav variant="pills" className="details-navbar">
                        <Nav.Item>
                          <Nav.Link
                            className="mobile-nav-links"
                            eventKey="photos"
                            style={{ color: style.linkColor }}
                          >
                            Photos
                        </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="mobile-nav-links"
                            eventKey="about"
                            style={{ color: style.linkColor }}
                          >
                            About
                        </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="mobile-nav-links"
                            eventKey="amenities"
                            style={{ color: style.linkColor }}
                          >
                            Amenities
                        </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="mobile-nav-links"
                            eventKey="map"
                            style={{ color: style.linkColor }}
                          >
                            Map
                        </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col
                      xs={12}
                      className="details-tab-content"
                      style={{
                        marginTop: "0px",
                        backgroundColor: "rgb(222, 222, 222)",
                      }}
                    >
                      <Tab.Content
                        style={{
                          backgroundColor: "rgb(222, 222, 222)",
                          marginTop: "0px",
                        }}
                      >
                        {/* Photos */}
                        <Tab.Pane eventKey="photos">
                          <Carousel activeIndex={index} onSelect={handleSelect} indicators={false}
                            style={{
                              backgroundColor: "#F7F7F7",
                            }}
                          >
                            {/* Vendor Units has images now */}
                            {vendor.vendorUnits && vendor.vendorUnits.some(u => u.vendorUnitId === selectedUnit && u.vendorUnitImages.length > 0) &&
                              vendor.vendorUnits.filter(u => u.vendorUnitId === selectedUnit).map((unit: VendorUnit) => {
                                return unit.vendorUnitImages.map((image: VendorUnitImage, index: number) => {
                                  return (<Carousel.Item
                                    key={`${unit.unitName}-${unit.vendorUnitId}-${index}`}
                                    style={{
                                      height: "auto",
                                      backgroundColor: "#F7F7F7",
                                    }}
                                  >
                                    <img
                                      className="d-block w-100"
                                      src={image.imageUrl}
                                      alt={image.name}
                                    />
                                    <Carousel.Caption>
                                      <p>{image.description}</p>
                                    </Carousel.Caption>
                                  </Carousel.Item>
                                  )
                                })
                              })
                            }

                            {vendor.vendorUnits && !vendor.vendorUnits.some(u => u.vendorUnitId === selectedUnit && u.vendorUnitImages.length > 0) && (
                              <img
                                className="d-block w-100"
                                style={{
                                  height: "400px",
                                  backgroundColor: "#F7F7F7",
                                }}
                                src={vendor.description != undefined && vendor.description.vendorDescriptionImages.length > 0 ? vendor.description.vendorDescriptionImages[0].vendorImageUrl as string : ""}
                                alt={""}
                              />
                            )}
                          </Carousel>
                        </Tab.Pane>
                        <Tab.Pane
                          className="p-3"
                          eventKey="about"
                          style={{ height: "auto" }}
                        >
                          <p style={{ color: style.fontColor }}>{vendor.description ? vendor.description.description : ""}</p>
                        </Tab.Pane>
                        <Tab.Pane
                          className="p-3"
                          eventKey="amenities"
                          style={{
                            backgroundColor: "rgb(222, 222, 222)",
                            height: "auto",
                          }}
                        >
                          {vendor.amenities.map((item: Amenity) => (
                            <p key={item.amenityName} style={{ backgroundColor: "rgb(222, 222, 222)", color: style.fontColor }}>
                              {item.amenityName}
                            </p>
                          ))}
                        </Tab.Pane>
                        <Tab.Pane eventKey="map" >
                          <div
                            className="d-flex flex-column align-items-center"
                          >
                            <iframe
                              className="mobile-map"
                              title="map"
                              // disableDefaultUI="true"
                              src={geoLocation}
                            ></iframe>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            )}
          </Col>
        </Col>
      </div>
    </React.Fragment >
  );
}

export default TransportDetails;